/* eslint-disable default-param-last */
export const UPDATE_LIST = 'PRACTITIONER_UPDATE_LIST'

type PractitionerItem = {
  id: string
  firstName: string
  lastName: string
}

type PractitionerState = {
  list: PractitionerItem[]
}

type Action = {
  type: string
  payload?: PractitionerItem[]
}

const initState: PractitionerState = {
  list: []
}

export default (
  state: PractitionerState = initState,
  action: Action
): PractitionerState => {
  switch (action.type) {
    case UPDATE_LIST:
      return {
        ...state,
        list: action.payload || []
      }
    default:
      return state
  }
}
